import { AxiosRequestCustomConfig, AxiosResponse, RequestParameter } from 'libs/axios';
import { apiClient } from 'libs/helpers';

const uploadImage: AxiosRequestCustomConfig<RequestParameter, AxiosResponse> = {
  url: 'upload',
};

export const uploadRepositories = {
  uploadImage: apiClient.postFn(uploadImage),
};
